import { sendToApi } from 'api/client'
import { ContentDefaults } from 'types'

export const ContentDefaultsClient = {
  getContentDefaults: () => sendToApi<ContentDefaults>('/content_defaults', { method: 'GET' }),
}
